/**
 * Currency picker — Markets localization form auto-submit.
 *
 * The footer renders {% form 'localization' %} with a
 * <select name="country_code">; this module submits the form on
 * change so the user doesn't need a submit button. Shopify sets
 * its own cookie and the next request re-renders prices and
 * checkout in the chosen country's currency.
 *
 * Replaces the pre-Markets cookie-based picker, which conflicted
 * with server-side Markets localization. See
 * .plans/_archive/20260603-markets-localization-cutover.md for
 * the full rationale.
 *
 * The change handler calls form.submit() rather than
 * form.requestSubmit() deliberately — bare .submit() bypasses
 * the submit event so Turbo's submit interceptor never sees it,
 * letting Shopify's POST → 302 → Set-Cookie chain run as a real
 * browser navigation. The form also carries data-turbo="false"
 * as defense-in-depth (see tests/static/turbo-form-opt-outs.test.js).
 *
 * Source path: theme/js/components/currency-picker.esm.js
 * Built name : ./currency-picker.js
 *
 * AI: Entirely written by AI
 * Date: 2026-06-03
 * Model: Claude Opus 4.7
 *
 * [CurrencyPicker]
 */

import { log } from './log.js';

const SELECT_SELECTOR = '.currency-picker__form [name="country_code"]';

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof Element) || !target.matches(SELECT_SELECTOR)) return;
  // Scope the form lookup via the select's surrounding wrapper rather
  // than the action attribute — `{% form 'localization' %}` renders
  // action="/<locale>/localization" on multi-language storefronts, so
  // a literal "/localization" match would silently break the day a
  // second storefront language is added.
  // Scope the form lookup via the .currency-picker__form class rather
  // than the action attribute — `{% form 'localization' %}` renders
  // action="/<locale>/localization" on multi-language storefronts, so
  // a literal "/localization" match would silently break the day a
  // second storefront language is added. Class-scoped also defends
  // against the picker being placed inside another <form> (browsers
  // disallow form nesting, but the class match keeps the contract
  // explicit either way).
  const form = target.closest('form.currency-picker__form');
  if (!form) return;
  log('[Currency] submitting localization form: ' + target.value);
  form.submit();
});

log('[CurrencyPicker] registered');
